import { RadioButton } from "primereact/radiobutton";
import {
  Controller,
  type FieldValues,
  type Path,
  type UseFormReturn,
} from "react-hook-form";
import { useTranslation } from "react-i18next";
import type { Gender } from "src/core/backend/clients/backendClient";
import { useProfile } from "src/features/auth/hooks/useProfile";

export interface GenderFormData extends FieldValues {
  gender?: Gender;
}

type GenderProps<T extends GenderFormData> = {
  form: UseFormReturn<T, any, T>;
  required: boolean;
};

export function GenderField<T extends GenderFormData>({
  form,
  required = true,
}: GenderProps<T>) {
  const { t } = useTranslation();
  const { genderOptions } = useProfile();

  const error = form.formState.errors.gender as Record<string, any> | undefined;

  return (
    <>
      <Controller
        name={"gender" as Path<T>}
        control={form.control}
        rules={{ required: required && t("Error.Required") }}
        render={({ field }) => (
          <div className="flex gap-2">
            {genderOptions.map((option) => (
              <div
                key={option.key}
                className="flex align-items-center"
              >
                <RadioButton
                  inputId={option.key}
                  value={option.value}
                  checked={field.value === option.value}
                  onChange={(e) => field.onChange(e.value)}
                />
                <label
                  htmlFor={option.key}
                  className="ml-2"
                >
                  {option.label}
                </label>
              </div>
            ))}
          </div>
        )}
      />
      {error && <small className="p-error block">{error.message}</small>}
    </>
  );
}
